import React from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import { Offcanvas } from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import testImg from "../assets/images/testImg.png";
import editBtn from "../assets/icons/mediaIcons/edit.png";
import deleteBtn from "../assets/icons/mediaIcons/delete.png";
import UploadImage from "../Components/UploadImage";
import Shimmer from "../Components/Shimmer";
import BannerHooks from "../hooks/Media/BannerHooks";
import MainInput from "../Components/MainInput";

const Media = () => {
  const {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    handleImageChange,
    handleLinkChange,
    link,
    handleSubmit,
    loading,
    banners,
    handleDelete,
    editMode,
    handleEdit,
    loadingAddBanner,
    deleteBannerLoading,
    imageForEdit,
    forUser,
    setForUser,
  } = BannerHooks();

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center justify-content-end">
            <AddInput onClick={handleShow} />
        </div>

        <div className="row">
          {loading
            ? Array.from({ length: 3 }, (_, index) => (
                <div key={index} className="col-md-6">
                  <div className="card border-0">
                    <Shimmer
                      style={{ height: "340px", borderRadius: "20px" }}
                    />
                    <div className="card-body">
                      <div className="text-center d-flex justify-content-center gap-3">
                        <Shimmer style={{ width: "310px", height: "33px" }} />
                        <Shimmer style={{ width: "310px", height: "33px" }} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : banners.map((banner) => (
                <div key={banner._id} className="col-md-6">
                  <div className="card border-0">
                    <img
                      src={banner.image || testImg}
                      height={340}
                      className="card-img-top"
                      alt={banner.altText || "Banner"}
                    />
                    <div className="card-body">
                      <div className="text-center w-100 d-flex justify-content-center">
                        <img
                          onClick={() => handleEdit(banner)}
                          className="cursor-pointer"
                          src={editBtn}
                          alt="editBtn"
                        />
                        {deleteBannerLoading[banner._id] ? (
                          <span className="text-center">
                            <i className="fa-solid fa-fan fa-spin fa-spin-reverse me-2"></i>
                          </span>
                        ) : (
                          <img
                            onClick={() => handleDelete(banner._id)}
                            className="cursor-pointer"
                            src={deleteBtn}
                            alt="deleteBtn"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </MainContainer>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>
            {editMode ? "Edit Banner" : "Add New Banner"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={handleSubmit}
          >
            <div>
              <UploadImage onChange={handleImageChange} edit={imageForEdit} />
              <MainInput
                label={"Link"}
                placeholder={"Enter Link....."}
                type={"text"}
                value={link}
                onChange={handleLinkChange}
              />
              {editMode ? (
                ""
              ) : (
                <div style={{ marginLeft: "35px", marginTop: "10px" }}>
                  <p>*if this checkbox isn't checked so it will send to the sellers.</p>
                  <label htmlFor="for-user-switch">Send for users</label>
                  <input
                    type="checkbox"
                    id="for-user-switch"
                    label="Send to all users"
                    style={{ marginLeft: "35px" }}
                    checked={forUser}
                    onChange={(e) => setForUser(e.target.checked)}
                  />
                </div>
              )}
            </div>

            <div className="d-flex justify-content-center align-items-center pb-3">
              <button className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold">
                {loadingAddBanner ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Media;
